import { useEffect, useState } from "react";
import { DialogContent, DialogTitle, DialogActions } from "@mui/material";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styles from "./addEmailModal.module.scss";
import UKDialog from "@/common-components-src/components/UKDialog/index";

import AddEmail from "@/app/csr-src/pages/profile/personalCenter/personalAccountSetDialog/components/email/addEmailDom";
import CommonButton from "@/app/csr-src/pages/order/components/commonButton";
interface addEmailModalProps {
  isOpen: boolean;
  closeHandler: () => void;
}

const addEmailModal: React.FC<addEmailModalProps> = observer(
  ({ isOpen, closeHandler }, { flag, userInfo, jumpToDialog, handleClose, freezeAccount, clonePop }: any) => {
    const { t } = useTranslation();

    const [pageFlag, setPageFlag] = useState("");

    useEffect(() => {
      flag && setPageFlag(flag);
    }, [flag]);
    // 跳转到某个页面
    const continueFn = (data: { type: string; flag: string; successText: string }) => {
      // jumpToDialog(data);
      // console.log('取消了')
      closeHandler()
    };
    return (
      <UKDialog
        open={isOpen}
        onClose={closeHandler}
        showCloseBtn={true}
        className={styles.repayOrderModal}
        sx={{
          "& .MuiDialog-paper": {
            width: "520px", // 设置自定义宽度
          },
        }}
      >
        <DialogTitle>Add Email</DialogTitle>
        <DialogContent>
          <div className={styles.email__wrap}>
            <AddEmail
              freezeAccount={freezeAccount}
              userInfo={userInfo}
              pageFlag={pageFlag}
              continueFn={continueFn}
              handleClose={handleClose}
              clonePop={clonePop}
            />
          </div>
        </DialogContent>
        <DialogActions>
          {/* <CommonButton variant="contained" onClick={closeHandler}>
          {t("common.btnText.ok")}
        </CommonButton> */}
        </DialogActions>
      </UKDialog>
    );
  },
);

export default addEmailModal;
